var React = require('react');

function LogoShapeBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M42.5652 -6.28957e-05L113.185 -6.59826e-05L113.185 126.468C113.279 135.41 111.529 144.279 108.039 152.548C104.549 160.817 99.3903 168.317 92.8694 174.602L71.2644 195.68L0 195.68L-6.73823e-06 41.5268C-7.21966e-06 30.5132 4.48452 19.9507 12.467 12.1629C20.4496 4.37509 31.2762 -6.24023e-05 42.5652 -6.28957e-05Z","fill":"#64C5FA"}));
}

LogoShapeBottom.defaultProps = {"viewBox":"0 0 114 196"};

module.exports = LogoShapeBottom;

LogoShapeBottom.default = LogoShapeBottom;
